import React from 'react';
import './CSS/Banner.css'

const Banner = () => {
    return (

        <header>
          <div className="headerText">
            <div>
              <h1 className = "BannerTitle">pick up your Present from here</h1>
              <p>Enjoy online shopping with Gift Point</p>
            </div>
          </div>
        </header>
    );
};

export default Banner;